import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'routes/AuthorizedRoute';

import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';

import ApkUpdateHome from './ApkUpdateHome';
import { URL, COMPONENT, APK_UPDATE_RESOURCES, GET_ACTION } from './helper';

const ApkUpdateInfo: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={PAGE_NAMES.dashboard}
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.apkUpdateInfo]}
					component={ApkUpdateHome}
				/>
				{_map(_values(APK_UPDATE_RESOURCES), (subEntity: string) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={PAGE_NAMES.dashboard}
						entity={DASHBOARD_RESOURCES.apkUpdateInfo}
						actions={[GET_ACTION[subEntity]]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.apkUpdateInfo]} />
			</Switch>
		</>
	);
};

export default ApkUpdateInfo;
